export const TypesDetalheDescarregaGate = {
    DETALHEDESCARREGA: "DETALHEDESCARREGA",
    SETTRANSPORTEMARIMEX: "SETTRANSPORTEMARIMEX",
    SETDESCRICAOVEICULORPR: "SETDESCRICAOVEICULORPR",
    RESETDETALHEDESCARREGAGATE: "RESETDETALHEDESCARREGAGATE",
    PREPARAOPERACAO: "PREPARAOPERACAO",
    GATE: "GATE",
    PROGRAMACAOID: "PROGRAMACAOID",
    RESETDESCARREGAGATE: "RESETDESCARREGAGATE",
    RETORNATELADETALHES: "RETORNATELADETALHES"
}

const INITIAL = {
    gateId: 0,
    empilhadeira: [],
    localOperacao: [],
    localSugestao: {},
    info: {},
    programacaoId: 0,

    transporteMarimex: false,
    retornaTelaDetalhes: false,
    reaproveitamento: false,
    descricaoVeiculoRPR: '',

    Titulo: '',
    ItemViagemID: 0,
    Msg: '',
    OperacaoStatus: '',
    Placa: '',
    Nodes: [],
}

export default function detalheDescarregaGateReducer(state = INITIAL, action) {

    switch (action.type) {
        case TypesDetalheDescarregaGate.DETALHEDESCARREGA:
            return {
                ...state,
                gateId: action.payload.gateId
            };
        case TypesDetalheDescarregaGate.SETTRANSPORTEMARIMEX:
            return {
                ...state,
                transporteMarimex: action.payload.transporteMarimex
            };
        case TypesDetalheDescarregaGate.SETDESCRICAOVEICULORPR:
            return {
                ...state,
                descricaoVeiculoRPR: action.payload.descricaoVeiculoRPR
            };
        case TypesDetalheDescarregaGate.PROGRAMACAOID:
            return {
                ...state,
                programacaoId: action.payload.programacaoId
            };
        case TypesDetalheDescarregaGate.PREPARAOPERACAO:
            return {
                ...state,
                empilhadeira: action.payload.dados.empilhadeira,
                localOperacao: action.payload.dados.localOperacao,
                localSugestao: action.payload.dados.localSugestao,
                info: action.payload.dados.info,
                programacaoId: action.payload.ID

            };
        case TypesDetalheDescarregaGate.GATE:
            return {
                ...state,
                Titulo: action.payload.Titulo,
                ItemViagemID: action.payload.ItemViagemID,
                Msg: action.payload.Msg,
                OperacaoStatus: action.payload.OperacaoStatus,
                Placa: action.payload.Placa,
                Nodes: action.payload.Nodes,
            };
        case TypesDetalheDescarregaGate.RESETDESCARREGAGATE:
            return {
                ...state,
                empilhadeira: INITIAL.empilhadeira,
                localOperacao: INITIAL.localOperacao,
            }
        case TypesDetalheDescarregaGate.RETORNATELADETALHES:
            return {
                ...state,
                retornaTelaDetalhes: action.payload
            }
        case TypesDetalheDescarregaGate.RESETDETALHEDESCARREGAGATE:
            return INITIAL;
        default:
            return state;
    }
}

export const DetalheDescarregaGateActions = {
    detalheDescarrega,
    setTransporteMarimex,
    setDescricaoVeiculoRPR,
    resetStateDetalheDescarrega,
    preparaOperacao,
    gate,
    setProgramacaoId,
    resetDescarregaGate,
    retornaTelaDetalhes
}

function detalheDescarrega(pgateId) {

    return {
        type: TypesDetalheDescarregaGate.DETALHEDESCARREGA,
        payload: { gateId: pgateId }
    }
}

function setTransporteMarimex(transporteMarimex) {
    return {
        type: TypesDetalheDescarregaGate.SETTRANSPORTEMARIMEX,
        payload: { transporteMarimex: transporteMarimex }
    }
}

function setDescricaoVeiculoRPR(descricaoVeiculoRPR) {
    return {
        type: TypesDetalheDescarregaGate.SETDESCRICAOVEICULORPR,
        payload: { descricaoVeiculoRPR: descricaoVeiculoRPR }
    }
}

function setProgramacaoId(id) {

    return {
        type: TypesDetalheDescarregaGate.PROGRAMACAOID,
        payload: { programacaoId: id }
    }
}

function preparaOperacao(dados, programacaoID) {

    return {
        type: TypesDetalheDescarregaGate.PREPARAOPERACAO,
        payload: { dados: dados, ID: programacaoID }
    }
}

function gate(dados) {

    return {
        type: TypesDetalheDescarregaGate.GATE,
        payload: dados
    }
}

function retornaTelaDetalhes(retornaTelaDetalhes) {
    return {
        type: TypesDetalheDescarregaGate.RETORNATELADETALHES,
        payload: retornaTelaDetalhes
    }
}

function resetStateDetalheDescarrega() {
    return { type: "RESETDETALHEDESCARREGAGATE" }
}

function resetDescarregaGate() {
    return { type: TypesDetalheDescarregaGate.RESETDESCARREGAGATE }
}